import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ 
    children, 
    adminOnly = false, 
    logisticsAllowed = false, 
    storeAllowed = false,
    catalogManagerAllowed = false,  // admin + responsabile_store (gestione catalogo)
    pvAllowed = false,  // route Preventivi PV accessibili al responsabile_store
    pvOnly = false  // New: block store_agent from PV routes
}) {
    const { user, loading, isAdmin, canAccessInventory, canAccessStore, canManageStoreCatalog, isStoreAgent, isStoreManager } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen bg-background flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Admin può accedere a tutto
    if (adminOnly && !isAdmin) {
        return <Navigate to="/" replace />;
    }

    // Gestione catalogo Store: admin + responsabile_store
    if (catalogManagerAllowed && !canManageStoreCatalog) {
        return <Navigate to="/" replace />;
    }

    // Se logisticsAllowed, permetti anche al ruolo logistica
    if (logisticsAllowed && !isAdmin && !canAccessInventory) {
        return <Navigate to="/" replace />;
    }

    // Se storeAllowed, permetti admin e store_agent
    if (storeAllowed && !isAdmin && !canAccessStore) {
        return <Navigate to="/" replace />;
    }

    // Se pvOnly, blocca store_agent (redirect a /store)
    if (pvOnly && isStoreAgent) {
        return <Navigate to="/store" replace />;
    }

    // Store agent può accedere SOLO alle route store e home
    // Blocca accesso a route PV se è store_agent e non siamo in /store
    if (isStoreAgent && !storeAllowed) {
        return <Navigate to="/store" replace />;
    }

    // Responsabile Store: solo Preventivi PV + modulo Store HVAC
    if (isStoreManager && !storeAllowed && !catalogManagerAllowed && !pvAllowed) {
        return <Navigate to="/store" replace />;
    }

    return children;
}
